import { db } from './firebase'
import { doc, getDoc, setDoc } from 'firebase/firestore'

const PRICE_COLLECTION = 'menuPrices'
const AVAIL_COLLECTION = 'menuAvailability'

// ─── Price overrides ───

export async function getPriceOverrides(businessKey) {
  try {
    const snap = await getDoc(doc(db, PRICE_COLLECTION, businessKey))
    if (!snap.exists()) return {}
    return snap.data().prices || {}
  } catch {
    return {}
  }
}

export async function savePriceOverride(businessKey, itemId, price) {
  const docRef = doc(db, PRICE_COLLECTION, businessKey)
  const snap = await getDoc(docRef)
  const existing = snap.exists() ? (snap.data().prices || {}) : {}
  existing[itemId] = price
  await setDoc(docRef, { prices: existing, updatedAt: new Date().toISOString() })
}

// ─── Availability overrides ───
// Stores { itemId: false } for disabled items. Missing = available.

export async function getAvailability(businessKey) {
  try {
    const snap = await getDoc(doc(db, AVAIL_COLLECTION, businessKey))
    if (!snap.exists()) {
      console.log('[Availability] No data found for', businessKey)
      return {}
    }
    const items = snap.data().items || {}
    const disabledCount = Object.values(items).filter(v => v === false).length
    console.log(`[Availability] Loaded for ${businessKey}: ${disabledCount} items disabled`)
    return items
  } catch (err) {
    console.error('[Availability] Failed to load:', err.message)
    return {}
  }
}

export async function setItemAvailability(businessKey, itemId, available) {
  const docRef = doc(db, AVAIL_COLLECTION, businessKey)
  const snap = await getDoc(docRef)
  const existing = snap.exists() ? (snap.data().items || {}) : {}
  existing[itemId] = available
  await setDoc(docRef, { items: existing, updatedAt: new Date().toISOString() })
}
